// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#authocyaninGene .el-button{background-color:#e1e1e1;color:#407338;border:#adadad;font-size:12px}#authocyaninGene .el-button:hover{background-color:#e5f1fb;color:#000}", ""]);
// Exports
module.exports = exports;
